import React, { VFC } from 'react';
import './SubscriptionCard.scss';
import { UserDetails } from '@/components/UserDetails';
import { ActionMenu } from '@/components/Elements/ActionMenu';
import { formatDate } from '@/utils/format';
import { Subscriber } from '../types';
type SubscriptionCard = {
  data: Subscriber;
  actionMenuOptions: any[];
};
const SubscriptionCard: VFC<SubscriptionCard> = ({ data, actionMenuOptions }) => {
  return (
    <div className="member-card-mobile">
      <div className="top-action">
        <span>{data.name}</span>
        <div className="right-action">
          <ActionMenu options={actionMenuOptions} />
        </div>
      </div>
      <div className="date-section">
        <span>Email</span>
        <span>{data.email}</span>
      </div>

      <div className="date-section">
        <span>Phone Number</span>
        <span>{data.phone}</span>
      </div>

      <div className="date-section">
        <span>Date Added</span>
        <span>{data.createdAt && formatDate(data.createdAt, 'DD MMM YYYY')}</span>
      </div>
    </div>
  );
};

export default SubscriptionCard;
